
// let serverBaseUrl = "http://127.0.0.1:8501/ordersvr";
let serverBaseUrl = "https://www.hahamiemie.com/ordersvr";

export {
	serverBaseUrl,
}